import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next'
import { Text, Flex, Box, Button } from 'components/primitives'
import Layout from 'components/Layout'
import seasonsHeader from '/public/seasonsBanner.png'
import seasonsMonthsGif from '/public/seasonsMonthsGif.gif'
import seasonsChart from '/public/seasonsChart.png'
import hunnysHeart from '/public/hunnysHeart.svg'
import endorseGif from '/public/endorseGif.gif'
import endorsements1 from '/public/endorsements1.png'
import endorsements2 from '/public/endorsements2.png'
import seasonsGif from '/public/seasonsGif.gif'
import { useTheme } from 'next-themes'
import { styled, globalCss, globalReset, darkTheme } from 'stitches.config';
import ThemeSwitcher from 'components/navbar/ThemeSwitcher'
import Image from 'next/image'
import { globalStyles } from 'stitches.config';
import { Luckiest_Guy } from '@next/font/google'
import { ComponentPropsWithoutRef, useContext, useState } from 'react'
import { ConnectWalletButton } from 'components/ConnectWalletButton'
import { Footer } from 'components/home/Footer'
import { useMediaQuery } from 'react-responsive'
import { useMarketplaceChain, useMounted } from 'hooks'
import { Card } from 'components/Card'
import { useAccount } from 'wagmi'
import { paths } from '@reservoir0x/reservoir-sdk'
import { useCollections } from '@reservoir0x/reservoir-kit-ui'
import fetcher from 'utils/fetcher'
import { NORMALIZE_ROYALTIES } from '../_app'
import supportedChains from 'utils/chains'
import Link from 'next/link'
import ChainToggle from 'components/common/ChainToggle'
import CollectionsTimeDropdown, {
  CollectionsSortingOption,
} from 'components/common/CollectionsTimeDropdown'
import { Head } from 'components/Head'
import { CollectionRankingsTable } from 'components/rankings/CollectionRankingsTable'
import { ChainContext } from 'context/ChainContextProvider'

type Props = InferGetStaticPropsType<typeof getStaticProps>

const List = styled('ul', {
  paddingLeft: '1em', // provide some space for custom bullet
  '& li': {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '-1em', // adjust as needed
      top: '0.5em', // adjust as needed
      width: '0.75em', // adjust as needed
      height: '0.75em', // adjust as needed
      background: `url("/hunnysHeart.svg") no-repeat`,
      backgroundSize: 'contain',
    },
  },
});

const luckiest_guy = Luckiest_Guy({
  subsets: ['latin'],
  weight: "400",
})

const backgroundImage = {
content: '""',
position: 'absolute',
top: 0,
left: 0,
height: '100%',
width: '100%',
zIndex: -1,
backgroundImage: `url('https://hunnys.io/wp-content/uploads/2022/11/Untitled-design-23.png')`,
backgroundRepeat: 'repeat',
backgroundPosition: 'center',
backgroundSize: 'tile',
opacity: 0.05
};

const AboutBlock = styled('div', {
  color: 'white',
  border: '3px solid #F4CC45',
  backgroundColor: '#5A1CDA',
  borderRadius: '5px',
  padding: '10px',
  marginBottom: '10px',
  '&:hover': {
    color: 'white',
    backgroundColor: '#9362F6',
  },
  '@dark': {
    backgroundColor: '$hunnysDarkPurple'
  }
})

const HunnysPage: NextPage<Props> = ({ ssr }) => {
  const isSSR = typeof window === 'undefined'
  const isMounted = useMounted()
  const compactToggleNames = useMediaQuery({ query: '(max-width: 800px)' })
  const [sortByTime, setSortByTime] =
    useState<CollectionsSortingOption>('1DayVolume')
  const marketplaceChain = useMarketplaceChain()
  const { isDisconnected } = useAccount()
  const card1Images = ["https://dl.openseauserdata.com/cache/originImage/files/cc98e7511c55d337862eb44be7147906.jpg", "https://dl.openseauserdata.com/cache/originImage/files/9035748af06c090ca87cbed516a9929a.jpg", "https://dl.openseauserdata.com/cache/originImage/files/5a877a76d5514c036118bf516bb39f7a.jpg", "https://dl.openseauserdata.com/cache/originImage/files/ce57c064e0db4a79c5957df8c3e8306b.jpg", "https://dl.openseauserdata.com/cache/originImage/files/bd340aa7398fc13b592d4634e7508241.jpg"];
  const card2Images = ["https://dl.openseauserdata.com/cache/originImage/files/95d16f32741034bfc3a50e87ab733643.jpg", "https://dl.openseauserdata.com/cache/originImage/files/046c0860114f288839d9392c3287237f.jpg", "https://dl.openseauserdata.com/cache/originImage/files/00a9e4b1156eaece56aecf49a0aae42b.jpg", "https://dl.openseauserdata.com/cache/originImage/files/b9de241636a93ee014b654aa4bf816c0.jpg", "https://dl.openseauserdata.com/cache/originImage/files/1a279c912c3b976ccf837b7ef06b814b.jpg"];
  const card3Images = ["https://dl.openseauserdata.com/cache/originImage/files/f31cf0715d4b91bb644d8c23ae3d4673.jpg", "https://dl.openseauserdata.com/cache/originImage/files/bc00242caae6b964d8f9767a8a036e3a.jpg", "https://dl.openseauserdata.com/cache/originImage/files/c336d4d0a5f13863edf6815da6a55580.jpg", "https://dl.openseauserdata.com/cache/originImage/files/75ff5200818da3149e78f116400d7c5b.jpg", "https://dl.openseauserdata.com/cache/originImage/files/874a854de5d67cb42497abf4cfacd65e.jpg", "https://dl.openseauserdata.com/cache/originImage/files/ef9ccd9f12ee1985a9466d24473778eb.jpg"];
  const card4Images = ["https://dl.openseauserdata.com/cache/originImage/files/71d7d82d2266dab0e7e1ccf4813f97cb.png", "https://dl.openseauserdata.com/cache/originImage/files/f70891858354912f15971a259fe42a61.jpg", "https://dl.openseauserdata.com/cache/originImage/files/bfb9239be1109ad11b7cb13d85c5cc28.png", "https://dl.openseauserdata.com/cache/originImage/files/e9abaee23be28be6ace0f19240e25bb0.jpg", "https://dl.openseauserdata.com/cache/originImage/files/8744b92b25af4f57e171f4084ead1b7d.png"];

  const { chain } = useContext(ChainContext)


  let volumeKey: ComponentPropsWithoutRef<
    typeof CollectionRankingsTable
  >['volumeKey'] = 'allTime'

  switch (sortByTime) {
    case '1DayVolume':
      volumeKey = '1day'
      break
    case '7DayVolume':
      volumeKey = '7day'
      break
    case '30DayVolume':
      volumeKey = '30day'
      break
  }

  return (
    <Layout>
      <Head />
      <Box
        css={{
          background: '#E170BB',
          p: 24,
          height: '100%',
          position: 'relative', // make sure it's relative
          '@bp800': {
            p: '$6',
          },
          '&::before': backgroundImage
        }}
      >
      <Flex
        direction="column"
        align="center"
        css={{ mx: 'auto', maxWidth: 728, pt: '$5', textAlign: 'center' }}
      >
      <Text css={{
          fontFamily: "Luckiest Guy, cursive",
          fontSize: "4rem",
          fontWeight: 100,
          letterSpacing: "1px",
          textTransform: "uppercase",
        }}>
          Hunnys Seasons
        </Text>
        <Image
          alt={`Hunnys Seasons Gif`}
          src={seasonsGif}
          width={200}
          style={{borderRadius:50}}
        />
        <Box css={{ alignSelf: 'center' }}>
          <Link href="/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b">
            <Button
              css={{
                minWidth: 224,
                marginTop: 50,
                justifyContent: 'center',
                fontFamily: "Luckiest Guy, cursive",
                background: '#3B66F5',
                color: '#FFF',
                '&:hover': {
                  backgroundColor: '#6CCBFA',
                },
                fontSize: "1.5rem",
                fontWeight: 100,
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
              size="large"
            >
              Shop Hunnys Seasons
            </Button>
          </Link>
        </Box>
        </Flex>
        {isDisconnected && (
          <Flex
            direction="column"
            align="center"
            css={{ mx: 'auto', maxWidth: 728, pt: '$5', textAlign: 'center' }}
          >
            <Text style="body1" css={{ mb: 48 }}>
            Connect your wallet to begin shopping, or to explore what you already own!
            </Text>
              <ConnectWalletButton />
          </Flex>
        )}
        <Flex css={{ my: '$6', gap: 65 }} direction="column">
        <Text css={{
            fontFamily: "Luckiest Guy, cursive",
            fontSize: "3rem",
            fontWeight: 100,
            letterSpacing: "1px",
            textTransform: "uppercase",
          }}>
        About
        </Text>
        <List css={{ textAlign: 'left', fontSize: 32}}>
            <li>Monthly Rewards for Hunnys 10k & Hunnys OG Holders</li>
            <li>Community-driven character creation & development</li>
            <li>No staking or claiming needed; airdropped every month</li>
            <li>Dynamic utility available in upcoming hunnys dapps</li>
            <li>Collectible, tradable, fun!</li>
        </List>
        <Text css={{
            fontFamily: "Luckiest Guy, cursive",
            fontSize: "3rem",
            fontWeight: 100,
            letterSpacing: "1px",
            textTransform: "uppercase",
          }}>
               Monthly Rewards
                </Text>
                <Flex
            justify="center"
            align="center"
            css={{
              flexDirection: 'column',
              marginRight: 'auto',
              gap: 12,
              '@bp1000': {
                alignItems: 'center',
                flexDirection: 'row',
                margin: 12,
              },
            }}
          >
            <Box css={{ width: 'calc(50%)', margin: '20px' }}>
              <Image
          alt={`Hunnys Seasons Gif`}
          src={seasonsMonthsGif}
          style={{width:'100%',maxWidth:720}}
        />
            </Box>
            <Box css={{ width: 'calc(50%)', margin: '20px' }}><Image
          alt={`Hunnys Seasons Gif`}
          src={seasonsChart}
          style={{width:'100%',maxWidth:720}}
        />
            </Box>

          </Flex>
                
<Text css={{
    fontFamily: "Luckiest Guy, cursive",
    fontSize: "3rem",
    fontWeight: 100,
    letterSpacing: "1px",
    textTransform: "uppercase",
  }}>
Popular Sets
</Text>
<Flex
  justify="center"
  align="stretch"
  css={{
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 24,
      '@bp1100': {
        justifyContent: 'space-between',
      },
      '@bp800': {
        justifyContent: 'space-between',
      },
      '@bp500': {
        justifyContent: 'center',
      },
    }}
    >
  <Card
    headline="Rainbow Beaches"
    carouselImages={card1Images}
    button3Link="/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b?attributes%5BSeason%5D=Rainbow+Mallow+Beaches"
    button3Text="SHOP"
  />
  <Card
    headline="30s Cartoon"
    carouselImages={card2Images}
    button3Link="/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b?attributes%5BSeason%5D=30s+Cartoon"
    button3Text="SHOP"
  />
  <Card
    headline="Badass Heroines"
    carouselImages={card3Images}
    button3Link="/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b?attributes%5BSeason%5D=Badass+Heroines"
    button3Text="SHOP"
  />
  <Card
    headline="Special"
    carouselImages={card4Images}
    button3Link="/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b?attributes%5BRarity%5D=Special"
    button3Text="SHOP"
  />
</Flex>
<Text css={{
    fontFamily: "Luckiest Guy, cursive",
    fontSize: "3rem",
    fontWeight: 100,
    letterSpacing: "1px",
    textTransform: "uppercase",
  }}>
More Information
</Text>
<script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
<Flex
            justify="center"
            align="center"
            css={{
              flexDirection: 'column',
              marginRight: 'auto',
              gap: 12,
              '@bp1000': {
                alignItems: 'center',
                flexDirection: 'row',
                margin: 12,
              },
            }}
          >
            <Box css={{ width: 'calc(33%)', margin: '20px' }}>
              <div dangerouslySetInnerHTML={{__html: `<blockquote class="twitter-tweet"><p lang="en" dir="ltr">✨What is Hunnys Seasons?✨<br><br>Learn more about our monthly rewards for Hunnys Holders (10k &amp; OG collections) below 👇 <a href="https://t.co/BTbrDgt27z">pic.twitter.com/BTbrDgt27z</a></p>&mdash; Hunnys 💛 (@HunnysNFT) <a href="https://twitter.com/HunnysNFT/status/1650982870712827904?ref_src=twsrc%5Etfw">April 25, 2023</a>
                </blockquote>
              `}} />
            </Box>
            <Box css={{ width: 'calc(33%)', margin: '20px' }}>
              <div dangerouslySetInnerHTML={{__html: `<blockquote class="twitter-tweet"><p lang="en" dir="ltr">🎉 ANNOUNCEMENT: Hunnys Seasons Holder Rewards! 🎉<br><br>Every Seasons drop is now a magical key, unlocking 1-10 exclusive Hunnys Closet items on Sept 12th! 🗝️✨<br><br>Been receiving our free airdrops for over a year? It&#39;s reward time, let creativity soar! 🍯🌼 <a href="https://twitter.com/hashtag/TheHunnysCloset?src=hash&amp;ref_src=twsrc%5Etfw">#TheHunnysCloset</a> <br><br>/👇 <a href="https://t.co/OqlGeElFIJ">pic.twitter.com/OqlGeElFIJ</a></p>&mdash; Hunnys 💛 | Closet Dropping Sept. 12 (@HunnysNFT) <a href="https://twitter.com/HunnysNFT/status/1698727742068466173?ref_src=twsrc%5Etfw">September 4, 2023</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
                </blockquote>
              `}} />
            </Box>
          </Flex>
          <Box css={{ alignSelf: 'center' }}>
            <Link href="/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b">
              <Button
                css={{
                  minWidth: 224,
                  marginTop: 50,
                  justifyContent: 'center',
                  fontFamily: "Luckiest Guy, cursive",
                  background: '#3B66F5',
                  color: '#FFF',
                  '&:hover': {
                    backgroundColor: '#6CCBFA',
                  },
                  fontSize: "1.5rem",
                  fontWeight: 100,
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                }}
                size="large"
              >
                Shop Hunnys Seasons
              </Button>
            </Link>
          </Box>
        </Flex>
        <Footer />
      </Box>
    </Layout>
  )
}


type CollectionSchema =
  paths['/collections/v5']['get']['responses']['200']['schema']
type ChainCollections = Record<string, CollectionSchema>

export const getStaticProps: GetStaticProps<{
  ssr: {
    collections: ChainCollections
  }
}> = async () => {
  let collectionQuery: paths['/collections/v5']['get']['parameters']['query'] =
    {
      sortBy: '1DayVolume',
      normalizeRoyalties: NORMALIZE_ROYALTIES,
      includeTopBid: true,
      limit: 10,
    }

  const promises: ReturnType<typeof fetcher>[] = []
  supportedChains.forEach((chain) => {
    const query = { ...collectionQuery }
    if (chain.collectionSetId) {
      query.collectionsSetId = chain.collectionSetId
    } else if (chain.community) {
      query.community = chain.community
    }
    promises.push(
      fetcher(`${chain.reservoirBaseUrl}/collections/v5`, query, {
        headers: {
          'x-api-key': chain.apiKey || '',
        },
      })
    )
  })
  const responses = await Promise.allSettled(promises)
  const collections: ChainCollections = {}
  responses.forEach((response, i) => {
    if (response.status === 'fulfilled') {
      collections[supportedChains[i].id] = response.value.data
    }
  })

  return {
    props: { ssr: { collections } },
    revalidate: 5,
  }
}

export default HunnysPage
